"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const absoluteUrlPattern = /^https?:\/\//i;
function isUrlAbsolute(url) {
  return absoluteUrlPattern.test(url);
}
function charactersSharedBetweenUrls(trunk, branch) {
  const charactersThatAreTheSame = branch.length - branch.replace(trunk, '').length;
  return charactersThatAreTheSame;
}
function getSimilarityOfUrls(urlA, urlB) {
  if (urlB === urlA) return Number.MAX_SAFE_INTEGER;
  const urlBContainsUrlA = urlB.startsWith(urlA);
  const urlAContainsUrlB = urlA.startsWith(urlB);
  if (!urlBContainsUrlA && !urlAContainsUrlB) return 0;
  return urlBContainsUrlA ? charactersSharedBetweenUrls(urlA, urlB) : charactersSharedBetweenUrls(urlB, urlA);
}
function stripTrailingSlashFromUrl(url) {
  return url.slice(-1) === '/' ? url.slice(0, -1) : url;
}
function getSimilarityToCurrentUrl(url, currentUrl) {
  const currentPort = window.location.port ? ":".concat(window.location.port) : '';
  const urlToCompareToCurrent = isUrlAbsolute(url) ? url : "".concat(window.location.protocol, "//").concat(window.location.hostname).concat(currentPort).concat(url, "/");
  return getSimilarityOfUrls(stripTrailingSlashFromUrl(urlToCompareToCurrent), stripTrailingSlashFromUrl(currentUrl));
}
const findMenuItemForUrl = menuTypes => (menuItems, url) => {
  let mostCharactersMatched = 0;
  let indexOfMatchedMenuItem = null;
  let menuOfMatchedMenuItem = null;
  menuTypes.forEach(menuType => {
    if (Array.isArray(menuItems[menuType])) {
      menuItems[menuType].forEach((menuItem, index) => {
        if (menuItem.link) {
          const similarityToCurrentUrl = getSimilarityToCurrentUrl(menuItem.link, url);
          if (similarityToCurrentUrl > mostCharactersMatched) {
            mostCharactersMatched = similarityToCurrentUrl;
            indexOfMatchedMenuItem = index;
            menuOfMatchedMenuItem = menuType;
          }
          return;
        }
        if (!menuItem.subMenu || menuItem.subMenu.length === 0) return;
        menuItem.subMenu.forEach(subMenuItem => {
          if (!subMenuItem.link || subMenuItem.link.indexOf('mailto:') === 0) return;
          const similarityToCurrentUrl = getSimilarityToCurrentUrl(subMenuItem.link, url);
          if (similarityToCurrentUrl > mostCharactersMatched) {
            mostCharactersMatched = similarityToCurrentUrl;
            indexOfMatchedMenuItem = index;
            menuOfMatchedMenuItem = menuType;
          }
        });
      });
    }
  });
  return menuOfMatchedMenuItem !== null && indexOfMatchedMenuItem !== null ? [menuOfMatchedMenuItem, indexOfMatchedMenuItem] : null;
};
var _default = exports.default = findMenuItemForUrl;